import { render, staticRenderFns } from "./MapperRelation.vue?vue&type=template&id=b037bde6&scoped=true&"
import script from "./MapperRelation.vue?vue&type=script&lang=js&"
export * from "./MapperRelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b037bde6",
  null
  
)

export default component.exports